import React, { useLayoutEffect } from "react";

import Ratio from "./ui/Ratio";
import useInstruments, { useInstrument } from "../hooks/useInstruments";
import { useRef } from "react";
import { useState } from "react";
import { i18n } from "@euroland/libs";
import TickerName from "./TickerName";

export default function MultipleTickerRadio() {
  const [{ instruments }] = useInstruments();
  const [{ selectedInstrument }, { onChangeSelectedInstrument }] = useInstrument();
  const radioElement = useRef();
  const [loading, setloading] = useState(true);

  // when have only one instrument, don't let the user handle
  const handleClickRaito = id => {
    if (Object.keys(selectedInstrument).length <= 1 && id in selectedInstrument) return;
    onChangeSelectedInstrument?.(id);
  };

  // scroll to active element
  useLayoutEffect(() => {
    const childern = radioElement.current.childNodes;
    let activeChildren = null;
    for (const i of childern) {
      if (i.className?.includes("checked")) {
        activeChildren = i;
        break;
      }
    }
    if (activeChildren) {
      // If default item have position < width wrapper parent
      // We dont scroll to this item
      const isRtl = window.appSettings.isRtl;
      const { width: widthDisplayRadioElement, left: positionLeftRadioElement } =
        radioElement.current.getBoundingClientRect();
      const { right: positionRightActiveChildren, left: positionLefActiveChildren } =
        activeChildren.getBoundingClientRect();
      if (isRtl && positionLefActiveChildren > 0) {
        setloading(false);
        return;
      }
      if (!isRtl && positionRightActiveChildren - positionLeftRadioElement <= widthDisplayRadioElement) {
        setloading(false);
        return;
      }

      activeChildren.scrollIntoView({
        block: "nearest",
        inline: "start",
        // behavior: "smooth",
      });

      // when scroll to element, we can't TAB on wrapper radio
      // we focus and remove focus on wrapper radio to handle issue
      radioElement.current.focus();
      radioElement.current.blur();

      const timer = setTimeout(() => {
        clearTimeout(timer);
        setloading(false);
      }, 100);
    }
  }, []);

  const handleKeyDown = e => {
    const code = e.keyCode ? e.keyCode : e.which;
    if (e.key === " ") {
      e.preventDefault();
    }
    // User press Tab
    // Scroll to current focusing element if radio ticker scroll
    if (code === 9) {
      const activeElement = document.activeElement;
      activeElement.scrollIntoView({
        block: "nearest",
        inline: "start",
        behavior: "smooth",
      });
      activeElement.focus({ preventScroll: true });
    }
    // active ticker when user press Enter
    else if (e.key === "Enter" || e.key === " ") {
      const activeElement = document.activeElement;
      const idTicker = activeElement.getAttribute("id-ticker");
      if (idTicker) handleClickRaito(Number(idTicker));
    }
  };

  return (
    <>
      <label htmlFor="multiple-ticker-radio" id="multiple-ticker-radio__label" className="screen-reader-only">
        {i18n.translate("tickerAriaLabel")}
      </label>
      <div
        className="MultipleTickerRadio"
        id="multiple-ticker-radio"
        onKeyDown={handleKeyDown}
        ref={radioElement}
        role="group"
        aria-labelledby="multiple-ticker-radio__label"
        style={{ opacity: loading ? 0 : 1 }}
      >
        {instruments.map(ticker => {
          const label = (
            <TickerName shareName={ticker.shareName} marketAbbreviation={ticker.marketAbbreviation} />
          );
          return (
            <Ratio
              {...ticker}
              key={ticker.instrumentId}
              checked={ticker.instrumentId in selectedInstrument}
              label={label}
              idTicker={ticker.instrumentId}
              onClick={() => handleClickRaito(ticker.instrumentId)}
            />
          );
        })}
      </div>
    </>
  );
}

MultipleTickerRadio.propTypes = {};
